import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { push } from "connected-react-router";
import RouteEnum from "constants/RouteEnum";
import i18n from "i18n";
import IAction from "models/IAction";
import React from "react";
import { Col, Row } from "react-bootstrap";
import { DispatchProp, connect } from "react-redux";
import ErrorAction from "stores/error/ErrorAction";
import IErrorState from "stores/error/models/IErrorState";
import UserAction from "stores/user/UserAction";
import IStore from "../../../models/IStore";
import { ReduxProps } from "../../../models/ReduxProps";
import BaseButton from "../base-form/BaseButton";
import BaseModal from "../base-form/BaseModal";

interface IProps {}

interface IState {
    showDetails: boolean;
    showUserUnauthorizedAlert: boolean;
}
interface IStateToProps {
    readonly errors: IErrorState;
    readonly hasErrors: boolean;
    readonly hasDetails: boolean;
    readonly showUserUnauthorizedAlert: boolean;
}

const mapStateToProps = (state: IStore): IStateToProps => ({
    errors: state.error,
    hasErrors: checkIfHasErrors(state.error),
    hasDetails: checkIfHasDetails(state.error),
    showUserUnauthorizedAlert: checkIfLoginRequiredOrUnauthorized(
        state.user.profile.isLoginRequired,
        state.user.profile.isLogged,
        state.error
    ),
});

const checkIfHasErrors = (errors: IErrorState) => {
    let result = false;
    if (Object.keys(errors).length > 0) {
        // console.log("checkIfHasErrors result " + Object.keys(errors).length);
        Object.keys(errors).forEach((error) => {
            const errorObj = errors[error].raw?.data;
            console.log("errorObj?.code " + errorObj?.code ?? "");
            if (errorObj && parseInt(errorObj.status) !== 500 && Object.keys(errors).length > 0) {
                console.log("errorObj?.code " + errorObj?.code ?? "");
                result = true;
            }
        });
        // console.log("checkIfHasErrors result " + result);
    }

    return result;
};

const checkIfHasDetails = (errors: IErrorState) => {
    let result = false;
    Object.keys(errors).forEach((error) => {
        const errorObj = errors[error].raw?.data;
        if (errorObj && (errorObj.detail || errorObj.additionalErrors)) {
            result = true;
        }
    });
    return result;
};

const checkIfUnauthorized = (errors: IErrorState) => {
    let result = false;
    Object.keys(errors).forEach((error) => {
        const errorObj = errors[error].raw?.data;
        if (errorObj && parseInt(errorObj.status) === 401) {
            //console.log("checkIfUnauthorized result true");
            result = true;
        }
    });
    // console.log("checkIfUnauthorized result " + result);
    return result;
};

const checkIfLoginRequiredOrUnauthorized = (isLoginRequired: boolean, isLogged: boolean, errors: IErrorState) => {
    if (isLoginRequired === true && isLogged === false) {
        // console.log("checkIfLoginRequiredOrUnauthorized result true");
        return true;
    } else {
        return checkIfUnauthorized(errors);
    }
};

const showErrorDetail = (errorObj: any) => (
    <>
        {errorObj?.detail ? <label>{errorObj?.detail}</label> : null}
        {errorObj?.title ? (
            <ul>
                <li>{errorObj?.title ? errorObj.title : ""}</li>;
            </ul>
        ) : null}

        {errorObj?.additionalErrors ? (
            <ul>
                {errorObj?.additionalErrors.map(function (item: any, i: number) {
                    return <li key={i}>{item?.code ? i18n.t("GLOBAL_SERVER_ERROR_" + item?.code) : ""}</li>;
                })}
            </ul>
        ) : null}
    </>
);

class ErrorViewer extends React.Component<IProps & IStateToProps & DispatchProp<IAction<any>>, IState> {
    constructor(props: IProps & IStateToProps & ReduxProps<any>) {
        super(props);
        this.state = {
            showDetails: false,
        } as IState;
    }

    private hasUnmounted = false;

    public componentWillUnmount() {
        this.hasUnmounted = true;
    }

    private setShowDetails = (showDetails: boolean) => {
        if (this.hasUnmounted === false) {
            this.setState({ ...this.state, showDetails });
        }
    };

    private toggleShowDetails = () => {
        this.setShowDetails(!this.state.showDetails);
    };

    private close = () => {
        // alla chiusura dell'overlay di errore vengono eliminati tutti gli errori dallo state
        this.props.dispatch(ErrorAction.clearAll());
        if (this.props.showUserUnauthorizedAlert === true) {
            this.props.dispatch(UserAction.setUserLogout());
            this.props.dispatch(push(RouteEnum().ACCESSO));
        }
    };

    public render(): JSX.Element {
        const { errors, hasErrors, hasDetails, showUserUnauthorizedAlert } = this.props;
        const { showDetails } = this.state;

        return (
            <>
                <BaseModal
                    show={showUserUnauthorizedAlert}
                    onHideHandler={this.close}
                    closeOnOutClick={false}
                    centered={true}
                    className="modal-danger"
                    title={
                        <label className="text-danger">
                            <FontAwesomeIcon icon="exclamation-circle" /> {i18n.t("global_error_unauthorized")}
                        </label>
                    }
                    body={
                        <Row>
                            <Col>{i18n.t("global_error_unauthorized_message")}</Col>
                        </Row>
                    }
                    footer={
                        <BaseButton
                            type="button"
                            color="bg-ecq-primary"
                            label={i18n.t("global_btn_accedi")}
                            onClickHandler={this.close}
                        />
                    }
                />
                <BaseModal
                    show={hasErrors && showUserUnauthorizedAlert === false}
                    onHideHandler={this.close}
                    closeOnOutClick={false}
                    centered={true}
                    className="modal-danger"
                    title={
                        <label className="text-danger">
                            <FontAwesomeIcon icon="exclamation-circle" /> {i18n.t("global_error_errore")}
                        </label>
                    }
                    body={
                        <Row>
                            <Col>
                                {Object.keys(errors).map(function (key) {
                                    const errorObj = errors[key].raw?.data;
                                    return (
                                        <div key={key}>
                                            {errorObj?.code === "DUPLICATE_EMAIL" ? (
                                                <>
                                                    <label>
                                                        {i18n.t("GLOBAL_SERVER_ERROR_DUPLICATE_EMAIL")}
                                                        <br />
                                                        {i18n.t("GLOBAL_SERVER_ERROR_DUPLICATE_EMAIL_SECONDO")}
                                                        <br />
                                                        {i18n.t("GLOBAL_SERVER_ERROR_DUPLICATE_EMAIL_TERZO")}
                                                        <br />
                                                        {i18n.t("GLOBAL_SERVER_ERROR_DUPLICATE_EMAIL_QUARTO")}
                                                        <br />
                                                    </label>
                                                    {showDetails ? <div>{showErrorDetail(errorObj)}</div> : null}
                                                </>
                                            ) : (
                                                <>
                                                    <label>{i18n.t(errorObj?.title ?? "GENERIC")}</label>
                                                    {/*showDetails ? <div>{showErrorDetail(errorObj)}</div> : null*/}
                                                </>
                                            )}
                                        </div>
                                    );
                                })}
                            </Col>
                        </Row>
                    }
                    footerClassName={hasDetails ? "d-flex justify-content-center" : undefined}
                    footer={
                        <>
                            {hasDetails ? (
                                <BaseButton
                                    type="button"
                                    color="bg-ecq-third"
                                    label={
                                        !showDetails
                                            ? i18n.t("global_mostra_dettagli")
                                            : i18n.t("global_nascondi_dettagli")
                                    }
                                    icon={!showDetails ? "eye" : "eye-slash"}
                                    onClickHandler={this.toggleShowDetails}
                                />
                            ) : null}
                            <BaseButton
                                type="button"
                                color="bg-ecq-fourth"
                                label={i18n.t("global_btn_chiudi")}
                                icon="times-circle"
                                onClickHandler={this.close}
                            />
                        </>
                    }
                />
            </>
        );
    }
}

export { ErrorViewer as Unconnected };
export default connect(mapStateToProps)(ErrorViewer);
